import _ from 'lodash';

export const hasAccessPermission = (permissions = [], resource, scope) => {
  const permissionsGranted = _.find(permissions, {'rsname': resource});
  if (!permissionsGranted) {
    return false;
  }

  const scopeGranted = permissionsGranted.scopes;
  return _.indexOf(scopeGranted, scope) !== -1;
};
